import { render, staticRenderFns } from "./InputTagWithOrderType.vue?vue&type=template&id=43c04808"
import script from "./InputTagWithOrderType.vue?vue&type=script&lang=js"
export * from "./InputTagWithOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports